<template>
  <v-dialog
    v-model="setDialog"
    :content-class="$vuetify.breakpoint.smAndDown
      ? 'detalhe-compra--mobile' : 'detalhe-compra--desktop'"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="320"
    persistent
  >
    <v-card
      class="grey lighten-3"
    >
      <v-app-bar
        v-if="$vuetify.breakpoint.smAndDown"
        max-height="48"
        class="px-0 gradiente-topo"
        dense
        dark
        app
        style="border-radius: 0;"
      >
        <div
          class="d-flex flex-no-wrap align-center"
          style="width: 100%;"
        >
          <v-btn
            :to="urlDetalheAssinatura"
            class="ml-0 mr-3 flex-shrink-0"
            data-cy="button_fechar_modal"
            icon
            small
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title
            v-if="!loading"
            class="text-truncate body-2 d-block"
            data-cy="titulo_modal"
          >
            {{ tituloCabecalho }}
          </v-toolbar-title>
        </div>
      </v-app-bar>

      <v-container
        tag="main"
        class="pt-12 pt-md-6"
        style="max-width:820px"
      >
        <v-btn
          v-if="$vuetify.breakpoint.mdAndUp"
          :to="urlDetalheAssinatura"
          absolute
          class="mt-n5 mr-n2"
          data-cy="button_fechar_modal"
          icon
          right
          small
          top
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <TituloPagina
          v-if="!erro"
          :class="$vuetify.breakpoint.mdAndUp ? 'headline' : ''"
          :titulo="tituloPagina"
          class="mt-4 mt-md-2"
        />

        <Loading v-if="loading" />

        <template v-else>
          <ErrorServidor v-if="erro" />

          <template v-else>
            <v-alert
              style="margin-top:60px !important"
              v-if="this.dadosCompra.order_bump_assinatura_show_message"
              class="mt-4"
              color="info"
              dark
              dense
            >
              Esta assinatura foi feita junto à outros produtos, por isso, o estorno ou reembolso da mesma pode ser realizado através do pedido do produto principal <b>{{this.dadosCompra.order_bump_assinatura_parent_product}}</b> da transação <b>{{this.dadosCompra.order_bump_assinatura_parent_order}}</b> em que a assinatura foi adquirida.
            </v-alert>
            <v-list
              :class="$vuetify.breakpoint.mdAndUp ? 'mt-11' : 'mt-3'"
              class="transparent py-0"
              data-cy="lista_gerenciar_assinatura"
            >
              <v-list-item
                v-if="habitarTrocaPagamento"
                data-cy="btn_trocar_assinatura"
                link
                class="pa-0 mt-1"
                :disabled="desabilitadoTrocaPagamento"
                @click="irParaTrocaPagamento"
              >
                <v-list-item-title
                  class="px-0 py-3 text-wrap"
                >
                  Trocar forma de pagamento
                </v-list-item-title>

                <v-list-item-icon class="my-auto">
                  <v-icon class="display-1">
                    mdi-chevron-right
                  </v-icon>
                </v-list-item-icon>
              </v-list-item>
              <v-divider v-if="habitarTrocaPagamento" />

              <v-list-item
                data-cy="btn_cancelar_assinatura"
                link
                class="pa-0 mt-1"
                :disabled="disabledLink()"
                @click="dialogCancelar = true"
              >
                <v-list-item-title
                  class="px-0 py-3 text-wrap"
                >
                  Cancelar assinatura
                </v-list-item-title>

                <v-list-item-icon class="my-auto">
                  <v-icon class="display-1">
                    mdi-chevron-right
                  </v-icon>
                </v-list-item-icon>
              </v-list-item>
              <v-divider />
            </v-list>
          </template>

          <BtnVoltar
            v-if="$vuetify.breakpoint.smAndDown"
            :voltar-para="urlDetalheAssinatura"
            max-width="800px"
          />
          <v-btn
            v-else
            :to="urlDetalheAssinatura"
            block
            class="mt-12"
            color="primary"
            data-cy="btn_voltar"
            outlined
          >
            Voltar
          </v-btn>
        </template>
      </v-container>

      <CancelarAssinatura
        :dialog="dialogCancelar"
        :codigo-venda="compraId"
        @changeDialog="fecharDialog => dialogCancelar = fecharDialog"
        @repostaApi="gravarRespostaNoStore"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import ApiCompras from '@/api/compras';
import { mapGetters, mapActions } from 'vuex';

import BtnVoltar from '@/components/BtnVoltar.vue';
import CancelarAssinatura from '@/components/Compras/CancelarAssinatura.vue';
import ErrorServidor from '@/components/ErrorServidor.vue';
import Loading from '@/components/Loading.vue';
import TituloPagina from '@/components/TituloPagina.vue';

export default {
  name: 'GerenciarAssinaturas',

  components: {
    BtnVoltar,
    CancelarAssinatura,
    ErrorServidor,
    Loading,
    TituloPagina,
  },

  props: {
    compraId: {
      type: Number,
      required: true,
    },
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      data: {},
      dialogCancelar: false,
      erro: false,
      loading: true,
      statusDesabilitaBtn: ['Cancelada'],
      tituloCabecalho: 'Gerenciar assinatura',
      tituloPagina: 'Gerenciar assinatura',
    };
  },

  computed: {
    ...mapGetters(['dadosCompra']),

    desabilitadoTrocaPagamento() {
      return this.disabledLink();
    },

    habitarTrocaPagamento() {
      return this.dadosCompra.membership_change_payment_method;
    },

    setDialog: {
      get() {
        return this.dialog;
      },
      set(v) {
        this.$emit('changeDialog', { visible: v });
      },
    },

    urlDetalheAssinatura() {
      return `/minhas-compras/detalhe-compra/${this.compraId}`;
    },
  },

  mounted() {
    this.verificarStore();
  },

  methods: {
    ...mapActions(['setAssinaturaCancelada', 'setReloadPage', 'gravarDadosCompra']),
    ...mapActions('meuperfil', ['setAssinaturaCadastrarCartao', 'setRecobrarAposCadastro']),

    irParaTrocaPagamento() {
      const permitePix = this.dadosCompra.membership_allows_pix === true;
      const atualBoleto = this.dadosCompra.membership_payment_method === 'boleto'
        || this.dadosCompra.membership_is_boleto === true;

      if (!permitePix && !atualBoleto) {
        // Sem PIX/boleto disponíveis: vai direto ao fluxo de cartão (sem tela de escolha).
        this.setAssinaturaCadastrarCartao(true);
        if (this.dadosCompra.assinaturaStatus === 'Inadimplente') {
          // Inadimplente: registra a intenção de recobrar a fatura pendente após salvar o cartão.
          this.setRecobrarAposCadastro(this.compraId);
        }
        this.$router.push('/meu-perfil/cartoes-credito/cadastrar');
      } else {
        this.$router.push(`/minhas-compras/gerenciar-pagamento-assinatura/${this.compraId}`);
      }
    },

    disabledLink() {
      const status = this.dadosCompra.venda === this.compraId
        ? this.dadosCompra.assinaturaStatus
        : this.data.membership_status;
      if (this.statusDesabilitaBtn.includes(status)) return true;

      return false;
    },

    async getApi(id) {
      this.erro = false;

      await ApiCompras.orderDetails(id)
        .then((response) => {
          this.data = response.data;
          this.gravarDadosCompra(this.data);
        })
        .catch(() => {
          this.erro = true;
        })
        .finally(() => {
          this.loading = false;
          this.tituloCabecalho = this.data.parent_product_name;
        });
    },

    gravarRespostaNoStore(sucesso) {
      this.setAssinaturaCancelada(sucesso);
      this.setReloadPage(true);
      this.$router.push(`/minhas-compras/detalhe-compra/${this.compraId}`);
    },

    verificarStore() {
      if (this.dadosCompra.venda === this.compraId) {
        this.tituloCabecalho = this.dadosCompra.produto;
        this.loading = false;
      } else {
        this.getApi(this.compraId);
      }
    },
  },
};
</script>

<style scope lang="scss">
html.overflow-y-hidden {
  overflow-y: hidden !important;
}

.detalhe-compra {
  &--desktop {
    border-bottom: 12px solid #EEE;
    border-radius: 1px !important;
    border-top: 12px solid #EEE;
    height: 100vh !important;
    margin: 0 0 0 auto !important;
    max-height: 100% !important;

    .v-sheet {
      border-radius: 1px !important;
      min-height: 100%;
    }
  }
}
</style>
